import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './physicalCards.module.scss';
import { actions } from '../../state';
import {
  formatDateTimeFromUnix,
  mapPhysicalCardDiscountState,
  mapPhysicalCardDiscountStateColor,
} from '../../utils';
import {
  ButtonSimple,
  Table,
  TableCell,
  TableRow,
  TitleSecondary,
} from '../../components';
import AddDiscount from './physicalCards.discount.add';
import { getMembershipLabel } from './physicalCards.helpers';

const tableHeader = ['Planas', 'Galioja nuo', 'Galioja iki', 'Būsena'];

const Discounts = ({ dispatch, cardId, assignments }) => {
  const openAddModal = () => {
    dispatch(actions.physicalCards.clearPhysicalCardDiscountErrorAction());

    dispatch(
      actions.modals.setModalVisible({
        modalName: 'defaultModal',
        title: 'Pridėti nuolaidos planą',
        withScroll: true,
        children: <AddDiscount cardId={cardId} />,
      })
    );
  };

  const rows = Array.isArray(assignments) ? assignments : [];

  const renderTable = () =>
    rows.map(assignment => {
      const state = assignment.discount_state;

      return (
        <TableRow key={assignment.id}>
          <TableCell>{getMembershipLabel(assignment)}</TableCell>
          <TableCell>
            {assignment.valid_from
              ? formatDateTimeFromUnix(assignment.valid_from)
              : '-'}
          </TableCell>
          <TableCell>
            {assignment.valid_to
              ? formatDateTimeFromUnix(assignment.valid_to)
              : '-'}
          </TableCell>
          <TableCell>
            <span style={{ color: mapPhysicalCardDiscountStateColor(state) }}>
              {mapPhysicalCardDiscountState(state)}
            </span>
          </TableCell>
        </TableRow>
      );
    });

  return (
    <div className={styles.discountsSection}>
      <div className={styles.discountsHeader}>
        <TitleSecondary>Nuolaidos planas</TitleSecondary>
        <ButtonSimple type="add" onClick={openAddModal}>
          Pridėti
        </ButtonSimple>
      </div>

      <Table header={tableHeader} isEmpty={!rows.length} loading={false}>
        {renderTable()}
      </Table>
    </div>
  );
};

Discounts.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      membership_id: PropTypes.number,
      membership: PropTypes.shape({
        title_lt: PropTypes.string,
      }),
      valid_from: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      valid_to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      discount_state: PropTypes.number,
    })
  ),
};

Discounts.defaultProps = {
  assignments: [],
};

export default connect()(Discounts);
